export const getLegendCategories = (json) => {
    const neededJson = json.Document.Folder;
    let allCategories = {};
    neededJson.forEach(markerObject => {
        allCategories[markerObject.name] = {
            name: markerObject.name,
            color: addMarkerColor(markerObject.name, neededJson)
        };
    });
    return allCategories;
};
const addMarkerColor = (markLookFor, jsonData) => {
    for (let key of Object.keys(jsonData)) {
        if (jsonData[key].name === markLookFor && jsonData[key].name !== 'Untitled layer') {
            return filterMarkerColor(Array.isArray(jsonData[key]['Placemark'])
                ? '#' + jsonData[key].Placemark[0].styleUrl
                : '#' + jsonData[key].Placemark.styleUrl);
        }
    }
};
const isValidColorString = part => part.length === 6 && part.substr(0, 1) !== '#';
const filterMarkerColor = string => string.split('-').find(isValidColorString);

export const getPointsList = (json) => {
    const neededJson = json.Document.Folder;
    let generatedPoints = [];

    for (let key of Object.keys(neededJson)) {
        let point = createPointsLogic(neededJson[key]);
        if (point) {
            generatedPoints = generatedPoints.concat(point);
        }
    }
    return generatedPoints
};

const isMarker = positionObject => {
    return typeof positionObject.Point !== 'undefined';
};

const convertToMarkerData = (type, data) => {
    let coordinates = data.Point.coordinates;
    return {
        type: type,
        headTitle: data.name,
        description: data.description,
        image: '',
        coordinates: createCoordinatesObject(coordinates)
    };
};

const convertToRouteData = (type, data) => {
    return {
        type: type,
        headTitle: data.name,
        description: data.description,
        image: '',
        color: pullColorFromRouteData(data.styleUrl),
        coordinates: getRouteObject(data.LineString.coordinates)
    }
}
const pullColorFromRouteData = styleUrl => {
    return styleUrl.split('-')[1];
}
const isRoute = positionObject => {
    return typeof positionObject.LineString !== 'undefined';
}
const createPointsLogic = (folder) => {
    let mapData = folder.Placemark;
    if (typeof mapData === 'undefined') {
        return [];
    }
    if (! Array.isArray(mapData)) {
        mapData = [mapData];
    }
    if (mapData.length === 0) {
        return [];
    }
    const firstMapData = mapData[0];

    if (isRoute(firstMapData)) {
        let allRoutes = [];
        for (let i = 0; i < mapData.length; i++) {
            allRoutes.push(convertToRouteData(folder.name, mapData[i]));
        }
        return allRoutes;
    }
    if (isMarker(firstMapData)) {
        let allMarkers = [];
        for (let i = 0; i < mapData.length; i++) {
            allMarkers.push(convertToMarkerData(folder.name, mapData[i]));
        }
        return allMarkers;
    }
    return null;
};
const createCoordinatesObject = string => {
    let coordinates = string.split(',')
    return {
        lat: parseFloat(coordinates[1]),
        lng: parseFloat(coordinates[0])
    };
};
const getRouteObject = string => {
    let finalRouteObject = [];
    const coordArray = string.split('\n');
    coordArray.forEach(coordinateData => {
        const splitCoord = coordinateData.trim().split(',');
        finalRouteObject.push(
            {
                lat: parseFloat(splitCoord[1]),
                lng: parseFloat(splitCoord[0])
            }
        );
    });
    return finalRouteObject.slice(1, -1);
};

export default {
    getPointsList,
    getLegendCategories
};



// WEBPACK FOOTER //
// ./js/Views/Modules/LocationMap/JsonHandler.js